document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-eba-uniform-select]');
  if (!select) return;
  const button = select.form.querySelector('button[type="submit"]');
  button.disabled = !select.value || select.selectedOptions[0].disabled;
});
document.querySelectorAll('[data-eba-uniform-select]').forEach((select) => {
  select.form.querySelector('button[type="submit"]').disabled = !select.value;
});
if (!customElements.get('eba-mobile-purchase')) {
  customElements.define('eba-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.target = document.getElementById(this.dataset.target);
      if (!this.target) return;
      this.button = this.querySelector('[data-eba-mobile-button]');
      this.price = this.querySelector('[data-eba-mobile-price]');
      this.size = this.querySelector('[data-eba-mobile-size]');
      this.chosen = false;
      this.updateBound = this.update.bind(this);
      this.changeBound = (event) => {
        if (event.target.closest('variant-selects')) this.chosen = true;
        this.update();
      };
      this.clickBound = () => {
        const nativeButton = this.target.querySelector('product-form button[name="add"]');
        const picker = this.target.querySelector('variant-selects');
        if (!this.chosen && picker) {
          picker.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          const first = picker.querySelector('input,select');
          if (first) first.focus({preventScroll: true});
          return;
        }
        if (nativeButton && !nativeButton.disabled && nativeButton.getAttribute('aria-disabled') !== 'true') nativeButton.click();
      };
      this.button.addEventListener('click', this.clickBound);
      this.target.addEventListener('change', this.changeBound);
      window.addEventListener('scroll', this.updateBound, {passive: true});
      window.addEventListener('resize', this.updateBound);
      this.observer = new MutationObserver(this.updateBound);
      this.observer.observe(this.target, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled','aria-disabled']});
      this.resizeObserver = new ResizeObserver(this.updateBound);
      this.resizeObserver.observe(this.target);
      this.update();
    }
    update() {
      const nativeButton = this.target.querySelector('product-form button[name="add"]');
      if (!nativeButton) { this.hidden = true; return; }
      const previewFrame = document.getElementById('PBarNextFrame');
      const previewRect = previewFrame ? previewFrame.getBoundingClientRect() : null;
      const offset = previewRect && previewRect.top < innerHeight && previewRect.bottom > innerHeight - 2 ? (previewRect.height > 120 ? 64 : previewRect.height) : 0;
      this.style.setProperty('--eba-preview-offset', offset + 'px');
      const rect = nativeButton.getBoundingClientRect();
      const nativeVisible = rect.top >= 0 && rect.bottom < innerHeight - offset;
      this.hidden = !matchMedia('(max-width: 749px)').matches || nativeVisible;
      const mainPrice = this.target.querySelector('.price--on-sale .price-item--sale') || this.target.querySelector('.price .price-item--regular');
      if (mainPrice) this.price.textContent = mainPrice.textContent.trim();
      const checked = this.target.querySelector('variant-selects input:checked');
      const selected = this.target.querySelector('variant-selects select');
      this.size.textContent = this.chosen ? (checked ? checked.value : selected ? selected.selectedOptions[0].textContent : '') : '';
      const hasPicker = !!this.target.querySelector('variant-selects');
      const unavailable = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = this.chosen && unavailable;
      this.button.textContent = !this.chosen && hasPicker ? this.dataset.choose : unavailable ? this.dataset.sold : this.dataset.add;
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.removeEventListener('scroll', this.updateBound);
      window.removeEventListener('resize', this.updateBound);
      if (this.target) this.target.removeEventListener('change', this.changeBound);
    }
  });
}